var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMortgageRepayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 65,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 53.116v-30l-17 30h17z",
    fill: "#E1F8F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M31 23.116h31v40H31z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33.116h9.5v-6H51l-3 6z",
    fill: "#E1F8F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27.116h23v6H35v-6z",
    stroke: "#10C98E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M35 37.116h5v5h-5zM44 37.116h5v5h-5zM53 37.116h5v5h-5zM35 46.116h5v5h-5zM44 46.116h5v5h-5zM53 46.116h5v5h-5zM35 54.116h5v5h-5zM44 54.116h5v5h-5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF1E0",
    stroke: "#7E776E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M53 54.116h5v5h-5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.461 25.116H12v-6h12.461c.848 0 1.539 1.347 1.539 3s-.683 3-1.539 3z",
    stroke: "#10C98E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.175 36.15h-7.52v-6.034h7.52c.511 0 .928 1.354.928 3.017 0 1.662-.412 3.017-.928 3.017zM19.175 46.15h-7.52v-6.034h7.52c.511 0 .928 1.354.928 3.017 0 1.662-.412 3.017-.928 3.017z",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 23.116v31h21.5M1 21.116l21.884-20 17.616 18.5",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgMortgageRepayment;